import { useRef, MouseEvent, useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import { CandidateDashboardModel, CandidateDashboardRating } from "../../../models/candidate/response/CandidateDashboardModel";
import candidateClasses from "../../../landing-pages/candidate/candidate.module.css";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { IAIEnum } from "../../../models/enums/IAIEnum";
import RatingDetailsPopUp from "./RatingDetailsComponent";
import DownloadBadgePopUp from "./DownloadBadgeComponent";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import modalUtils from "../../../utils/modal-utils";
import CandidateService from "../../../services/candidate/candidate-service";
import toasterUtils from "../../../utils/toaster-utils";
import loaderUtils from "../../../utils/loader-utils";
import { Button } from "@mui/material";

interface CandidateDashboardRatingProps {
    objCandidateDashboardDetails: CandidateDashboardRating;
}

const CandidateDashboardRatingComponent = (props: CandidateDashboardRatingProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [candidateDashboardDetails, setCandidateDashboardDetails] = useState<CandidateDashboardRating>(props.objCandidateDashboardDetails);

    const viewRating = () => {
        modalUtils.showLoader();
        CandidateService.getInterviewRatingDetails(props.objCandidateDashboardDetails.interviewId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.isSuccess) {
                const config: GeneralPoupConfig = {
                    title: (
                        <>
                            Feedback Report
                        </>
                    ),
                    content: (
                        <RatingDetailsPopUp
                            objRatingDetails={res.data}
                        />
                    ),
                    size: ModalSize.XL,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            } else {
                toasterUtils.showError(res.errorMessages.toString());
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Schedules");
        });
    };

    const viewBadge = () => {
        modalUtils.showLoader();
        CandidateService.getInterviewRatingDetails(props.objCandidateDashboardDetails.interviewId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.isSuccess) {
                const config: GeneralPoupConfig = {
                    title: "Download Badge",
                    content: (
                        <DownloadBadgePopUp
                            objRatingDetails={res.data}
                        />
                    ),
                    size: ModalSize.XL,
                    className: "model-badge"
                };
                modalUtils.showPopup(config);
            } else {
                toasterUtils.showError(res.errorMessages.toString());
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Schedules");
        });
    };

    return (
        <div>
            <div className="row">
                <div className="col-lg-4 col-md-4 donut-chart">
                    <div className={candidateClasses.ratingDonut}>
                        <CircularProgressbar
                            value={(Number(candidateDashboardDetails.totalRating) / IAIEnum.MaxRating) * 100}
                            text={`${Math.round((Number(candidateDashboardDetails.totalRating) / IAIEnum.MaxRating) * 100)}%`}
                            strokeWidth={7}
                            styles={buildStyles({
                                pathColor: "#3f7ed5",
                                trailColor: "#eee",
                                textColor: "#333",
                                textSize: "16px",
                                pathTransitionDuration: 0.5
                            })}
                        />
                    </div>
                </div>
                <div className="col-lg-8 col-md-8">
                    {candidateDashboardDetails.candidateDashboardRatingDetails.map((field, index) => (
                        <div className="row">
                            <div className="col-lg-9 col-md-9 ">{field.secondarySkillName}:</div>
                            <div className="col-lg-3 col-md-3">{field.rating}</div>
                        </div>
                    ))}
                </div>
                <div className="rating-badge-wrapper">
                        <Button variant="outlined" color="primary" onClick={viewRating} size="small">
                            View Rating
                        </Button>
                        <Button variant="outlined" color="primary" onClick={viewBadge} size="small">
                            View Badge
                        </Button>
                </div>
            </div>
        </div>
    );
};
export default CandidateDashboardRatingComponent;